import type { ReactNode } from 'react';
import React from 'react';
import type { FormatOptionLabelMeta } from 'react-select-modern';

import * as styles from './FacebookAgeSelect.css';

export interface IAge {
  id: number;
  name: string;
}

/* UniversalSelect calls this for both the menu rows and the selected value. */
export function formatAgeOptionLabel(data: IAge, meta: FormatOptionLabelMeta<IAge>): ReactNode {
  if (meta.context === 'value') {
    return data.name;
  }

  return <div className={styles.description}>{data.name}</div>;
}
